import { render } from "./EditEntitlement.vue?vue&type=template&id=00f2a571"
import script from "./EditEntitlement.vue?vue&type=script&lang=js"
export * from "./EditEntitlement.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__